import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import { BaseModel } from "model/BaseModel";
import Processo from "model/indicadores/Processo";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import ProcessoService from "service/indicadores/ProcessoService";

const processoService = new ProcessoService();

export default function ProcessoCadastro() {

    const [processo, setProcesso] = useState<Processo>(new Processo());
    const [titulo, setTitulo] = useState<string>('Processo');

    const { register, control, handleSubmit, setFocus, clearErrors, setError, formState: { errors } } = useForm();

    function validar() {
        if (!processo.codigoInterno) {
            setError("codigoInterno", { type: "manual", message: "Código é obrigatório." }, { shouldFocus: true });
            return false;
        }
        if (!processo.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório." }, { shouldFocus: true });
            return false;
        }
        return true;
    }

    return (
        <BaseCadastro model={processo} service={processoService} setModel={(value: Processo) => setProcesso(value)} validar={() => validar()} pathCadastro={"/processo"} urlService={"/processo"} tituloPagina={titulo}>
            <div className="row">
                <Label className="col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <Controller name="codigoInterno" control={control} render={({ field }) => (
                        <InputNumber required
                            inputRef={field.ref}
                            className={errors.codigoInterno ? "p-invalid" : ""}
                            value={processo.codigoInterno}
                            onChange={(e) => setProcesso({ ...processo, codigoInterno: e.value as number })}
                            style={{ width: '30%' }}
                            locale="pt-BR"
                            useGrouping={false}
                            maxFractionDigits={0}
                        />
                    )} />
                </div>
                {errors.codigoInterno && errors.codigoInterno.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigoInterno?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText className={errors.nome ? "p-invalid" : ""} value={processo.nome} style={{ width: '100%' }} {...register("nome", {
                        onChange: (e) => {
                            clearErrors("nome")
                            setProcesso({ ...processo, nome: e.target.value })
                        }
                    })} />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>
        </BaseCadastro>
    )
}
